<template>
    <div>
        <div :class="timerclass">{{ timestr }}</div>
    </div>
</template>

<script>
export default {
    name: "reduction_timer",
    props: {
        timeStart: String,
        timeEnd: String,
        title: String,
        serverNow: String,
    },
    
    data() {
        return {
            timestr: '',
            timerclass: '',
            interval: null,
            serverDiffMs: 0,
            lastSecondSync: false,
            currentIntervalMs: 1000
        }
    },
    
    mounted() {
        this.syncServerTime();
        this.timer();
        this.startTimerLoop();
    },
    
    beforeDestroy() {
        this.stopTimerLoop();
    },
    
    computed: {
        _timestart() {
            return this.parseDate(this.timeStart);
        },
        
        _timeend() {
            return this.parseDate(this.timeEnd);
        }
    },
    
    watch: {
        serverNow() {
            this.syncServerTime();
        },
        timeStart() {
            this.lastSecondSync = false;
            this.timer();
            this.restartTimerLoopIfNeeded();
        },
        timeEnd() {
            this.lastSecondSync = false;
            this.timer();
            this.restartTimerLoopIfNeeded();
        }
    },
    
    methods: {
        parseDate(value) {
            if (!value) return null;
            
            if (typeof value === 'number') {
                return value;
            }
            
            if (typeof value !== 'string') {
                return null;
            }
            
            const normalized = value.replace(' ', 'T');
            const ts = Date.parse(normalized);
            
            return Number.isNaN(ts) ? null : ts;
        },
        
        syncServerTime() {
            const serverTs = this.parseDate(this.serverNow);
            if (!serverTs) return;
            
            this.serverDiffMs = serverTs - Date.now();
            this.timer();
            this.restartTimerLoopIfNeeded();
        },
        
        getServerNow() {
            return Date.now() + this.serverDiffMs;
        },
        
        getTickInterval() {
            if (!this._timeend) {
                return 1000;
            }
            
            const now = this.getServerNow();
            const msLeft = this._timeend - now;
            
            if (msLeft <= 10000 && msLeft > 0) {
                return 500;
            }
            
            return 1000;
        },
        
        startTimerLoop() {
            this.stopTimerLoop();
            
            this.currentIntervalMs = this.getTickInterval();
            
            this.interval = setInterval(() => {
                this.timer();
                
                const nextInterval = this.getTickInterval();
                if (nextInterval !== this.currentIntervalMs) {
                    this.startTimerLoop();
                }
            }, this.currentIntervalMs);
        },
        
        stopTimerLoop() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        
        restartTimerLoopIfNeeded() {
            const nextInterval = this.getTickInterval();
            if (nextInterval !== this.currentIntervalMs) {
                this.startTimerLoop();
            }
        },
        
        timer() {
            if (!this._timestart || !this._timeend) {
                this.timestr = '';
                this.timerclass = '';
                return;
            }
            
            const now = this.getServerNow();
            
            if (now > this._timeend) {
                this.timestr = this.title + " завершено " + this.timeEnd;
                this.timerclass = 'complite p-2 mb-4';
                this.stopTimerLoop();
                return;
            }
            
            let diff = 0;
            
            if (now < this._timestart) {
                diff = Math.floor((this._timestart - now) / 1000);
                
                let tsec = diff % 60;
                diff = Math.floor(diff / 60);
                
                let tmin = diff % 60;
                diff = Math.floor(diff / 60);
                
                let thour = diff % 24;
                let tday = Math.floor(diff / 24);
                
                if (tsec < 10) tsec = '0' + tsec;
                if (tmin < 10) tmin = '0' + tmin;
                
                if (tday > 0) {
                    this.timestr = this.title + " почнеться через " + tday + " дн. " + thour + " год. " + tmin + " хв. " + tsec + " сек.";
                } else {
                    this.timestr = this.title + " почнеться через " + thour + " год. " + tmin + " хв. " + tsec + " сек.";
                }
                
                this.timerclass = 'infuture p-2 mb-4';
                return;
            }
            
            diff = Math.floor((this._timeend - now) / 1000);
            
            if (diff <= 1 && !this.lastSecondSync) {
                this.lastSecondSync = true;
                this.$emit('force-update');
            }
            
            let tsec = diff % 60;
            diff = Math.floor(diff / 60);
            
            let tmin = diff % 60;
            diff = Math.floor(diff / 60);
            
            let thour = diff % 24;
            let tday = Math.floor(diff / 24);
            
            if (tsec < 10) tsec = '0' + tsec;
            if (tmin < 10) tmin = '0' + tmin;
            
            if (tday > 0) {
                this.timestr = this.title + " завершиться через " + tday + " дн. " + thour + " год. " + tmin + " хв. " + tsec + " сек.";
            } else {
                this.timestr = this.title + " завершиться через " + thour + " год. " + tmin + " хв. " + tsec + " сек.";
            }
            
            this.timerclass = 'nowactive p-2 mb-4';
        }
    }
}
</script>

<style scoped>
</style>